var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaMapMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.1714C21.5 17.1714 12.5 23.1714 12.5 23.1714C12.5 23.1714 3.5 17.1714 3.5 10.1714C3.5 7.78444 4.44821 5.49525 6.13604 3.80743C7.82387 2.1196 10.1131 1.17139 12.5 1.17139C14.8869 1.17139 17.1761 2.1196 18.864 3.80743C20.5518 5.49525 21.5 7.78444 21.5 10.1714Z",
    stroke: "#333939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.1714C14.1569 13.1714 15.5 11.8282 15.5 10.1714C15.5 8.51453 14.1569 7.17139 12.5 7.17139C10.8431 7.17139 9.5 8.51453 9.5 10.1714C9.5 11.8282 10.8431 13.1714 12.5 13.1714Z",
    stroke: "#333939",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.171387)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaMapMarker);
export default __webpack_public_path__ + "static/media/faMapMarker.48ea617d1a903bb57961e906a63d8411.svg";
export { ForwardRef as ReactComponent };